import React, { useState, useEffect } from "react";
import clienteAxios from "../../Config/Axios";
import { MenuItem, Select, InputLabel, FormControl, Box } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
	formControl: {
		width: "100%",
		marginBottom: theme.spacing(2),
	},
}));

export default function SelectBranch(props) {
	const classes = useStyles();
	const [offices, saveOffices] = useState([]);

	useEffect(() => {
		const getOffices = async () => {
			try {
				const res = await clienteAxios.get("/branches");
				saveOffices(res.data.data);
			} catch (error) {
				console.log(error);
			}
		};
		getOffices();
	}, []);

	const detectarCambiosOffice = (e) => {
		props.detectarCambiosOffice(e);
	};

	return (
		<Box>
			<FormControl variant="outlined" className={classes.formControl}>
				<InputLabel id="select-branch-label">Selecciona una sucursal</InputLabel>
				<Select
					labelId="select-branch-label"
					id="select-branch"
					label="Selecciona una sucursal"
					fullWidth
					onChange={detectarCambiosOffice}
					defaultValue=""
				>
					<MenuItem value="" disabled>
						<em>Selecciona la sucursal</em>
					</MenuItem>
					{offices.map((office) => (
						<MenuItem key={office.id} value={office.id}>
							{office.name}
						</MenuItem>
					))}
				</Select>
			</FormControl>
		</Box>
	);
}
